import React, { Component } from 'react';
import PropTypes from 'prop-types';
import InputEditAble from 'components/inputEditAble';
import { Modal } from 'react-bootstrap';
import { CheckBoxSingle } from 'components/checkboxes/check-box-single';
import { Panel, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { v4 as uuidv4 } from 'uuid';
import filter from 'lodash/filter';
import isEmpty from 'lodash/isEmpty';
class MediaLibraryEditItemModal extends Component {
  static propTypes = {
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
    item: PropTypes.object,
    onUpdateVideoName: PropTypes.func,
    onFetchCategory: PropTypes.func,
    MediaCategories: PropTypes.array,
    SelectListRegions: PropTypes.array,
    onFetchRegion: PropTypes.func,
    onFetchProject: PropTypes.func,
    ProjectList: PropTypes.array,
    onCopyProject: PropTypes.func,
    onCheckCopyProjectDuplicate: PropTypes.func,
    onCheckCopyByRegion: PropTypes.func,
    ListCheckCopiedRegion: PropTypes.array,
    onUpdateCategory: PropTypes.func
  };
  constructor(props) {
    super(props);
    this.uuid = uuidv4();
    this.state = {
      openCopyMedia: true,
      openMedia: false,
      panelToggle: false,
      editVideoName: false,
      onCheckCopyRegion: false,
      checkItemsState: {
        data: []
      },
      warningState: {},
      warningProjectState: {}
    };
  }
  componentDidMount() {
    this.onFetchCategory();
  }
  componentWillReceiveProps(nextProps) {

    if (nextProps.ProjectList.length > 0) {
      if (this.state.checkItemsState.data.length === 0) {
        this.initCheckItemState(nextProps.ProjectList, false);
      }
    }
    if (nextProps.ListCheckCopiedRegion.length > 0) {
      if (this.state.warningState) {
        this.initWarningState(nextProps.ListCheckCopiedRegion);
      }
    }
  }
  onClose = () => {
    this.props.onClose();
  };

  onCheckedCategories = (mediaCategoryId) => {
    const { item } = this.props;

    if (isEmpty(item.category)) {
      this.props.onUpdateCategory({
        id: item.id,
        mediaCategoryId: mediaCategoryId
      });
      this.setState({
        openMedia: !this.state.openMedia
      });
    }
    if (!isEmpty(item.category) && item.category.id === mediaCategoryId) {
      this.setState({
        openCopyMedia: !this.state.openCopyMedia
      });
    }
  }

  onCheckCategory= (e, value, data) => {
    const { item } = this.props;

    this.props.onUpdateCategory({
      id: item.id,
      mediaCategoryId: data.checked ? value : null
    });
    this.setState({
      openMedia: !this.state.openMedia
    });
  }

  onEditVideoName = () => {
    this.setState({
      editVideoName: !this.state.editVideoName
    });
  };

  onUpdateVideoName = param => {
    const { item } = this.props;
    const splitUrl = item.url.split('.');
    const fileExtension = splitUrl[splitUrl.length - 1];
    this.props.onUpdateVideoName(
      {
        id: item.id,
        fileName: `${param.fileName}.${fileExtension}`
      },
      this.setState({
        editVideoName: false
      })
    );
  };
  onFetchCategory = () => {
    this.props.onFetchCategory();
  };
  onFetchRegion = () => {
    this.props.onFetchRegion();
  };
  onFetchProject = () => {
    this.props.onFetchProject();
  };
  onDetectFileName = () => {
    const { item } = this.props;
    const { fileName } = item;
    if (fileName.includes('.')) {
      const splitFileName = fileName.split('.');
      const fileExtension = splitFileName[splitFileName.length - 1];
      const name = fileName.replace(`.${fileExtension}`, '');
      return name;
    }
    return fileName;
  };
  regionEnabled = () =>
    window.profile.regionAndMarket === 1 ||
    window.profile.regionAndMarket === 2;
  initWarningState(checkList) {
    let {warningState} = this.state;
    checkList.map(item => {
      warningState[item.projectId] = item.copied;
    });

    this.setState({
      warningState: warningState
    });
  }
  initCheckItemState(projectList, reset) {
    // Hard code region settings for demo only
    const regionEnabled = this.regionEnabled();
    // Initialize state
    let { checkItemsState } = this.state;
    if (reset === true) {
      checkItemsState.data = [];
    }
    // Region is enabled => Set state data with structure { data: [{regionId: ..., checked: ..., projects: [{projectId: ..., checked: ...}]}] }
    if (regionEnabled) {
      // Get regions from project list
      const projectRegions = projectList.map(item => item.region.id);
      // Distinct region and return region IDs only
      const regionIds = projectRegions.filter(
        (value, index) => projectRegions.indexOf(value) === index
      );
      regionIds.map(regionId => {
        const projects = projectList
          .filter(project => project.region.id === regionId)
          .map(selectedItem => {
            return {
              projectId: selectedItem.id,
              checked: false
            };
          });
        const checkItem = {
          regionId: regionId,
          checked: false,
          projects: projects,
          numberOfProjects: projects.length
        };
        checkItemsState.data.push(checkItem);
      });
    } else {
      // Region isn't enabled => Set state data with structure { data: [{projectId: ..., checked: ...}] }
      projectList.map(selectedItem => {
        checkItemsState.data.push({
          projectId: selectedItem.id,
          checked: false
        });
      });
    }
    this.setState({
      checkItemsState: checkItemsState
    });
  }

  onCopy = () => {
    const checkedProjectIds = this.getCheckedProjects();
    const {ProjectList} = this.props;
    this.props.onCopyProject({
      mediaId: this.props.item.id,
      projectIds: checkedProjectIds
    }, this.initCheckItemState(ProjectList, true));
  };
  onCheckRegion = (e, value, data) => {
    const {ProjectList, item} = this.props;
    let projectIds = ProjectList.filter(a => a.region.id === data.value).map(i => i.id);
    let { checkItemsState } = this.state;
    for (let i = 0; i < checkItemsState.data.length; i++) {
      if (checkItemsState.data[i].regionId === value) {
        // Set region
        checkItemsState.data[i].checked = data.checked;
        // Set projects
        for (let j = 0; j < checkItemsState.data[i].projects.length; j++) {
          checkItemsState.data[i].projects[j].checked = data.checked;
        }
        break;
      }
    }
    this.setState({
      checkItemsState: checkItemsState
    });

    this.searchInput.value = '';
    data.checked === true && this.props.onCheckCopyByRegion({
      mediaId: item.id,
      projectIds: projectIds
    });
  };
  onCheckProject = (e, value, data) => {
    const { item } = this.props;
    const regionEnabled = this.regionEnabled();
    let { checkItemsState } = this.state;
    if (regionEnabled) {
      for (let i1 = 0; i1 < checkItemsState.data.length; i1++) {
        // Set projects
        for (let j = 0; j < checkItemsState.data[i1].projects.length; j++) {
          if (checkItemsState.data[i1].projects[j].projectId === value) {
            checkItemsState.data[i1].projects[j].checked = data.checked;
            break;
          }
        }
        // All project are unchecked
        if (checkItemsState.data[i1].projects.every(x => x.checked === false)) {
          checkItemsState.data[i1].checked = false;
        }
        // At least 1 project checked
        if (checkItemsState.data[i1].projects.some(x => x.checked === true)) {
          checkItemsState.data[i1].checked = true;
        }
      }
    } else {
      for (let i2 = 0; i2 < checkItemsState.data.length; i2++) {
        if (checkItemsState.data[i2].projectId === value) {
          checkItemsState.data[i2].checked = data.checked;
          break;
        }
      }
    }

    data.checked === true &&
      this.props.onCheckCopyProjectDuplicate({
        mediaId: item.id,
        projectId: value
      });

    this.setState({
      checkItemsState: checkItemsState
    });
  };
  getRegionCheckState = regionId => {
    let { checkItemsState } = this.state;
    const regionState = checkItemsState.data.filter(
      item => item.regionId === regionId
    )[0];
    if (!regionState || (regionState && !regionState.checked)) {
      return 'unchecked';
    }
    return regionState.checked && regionState.projects.every(x => x.checked)
      ? 'checked'
      : 'indeterminate';
  };
  getRegionDisableState = regionId => {
    let { checkItemsState } = this.state;
    const regionState = checkItemsState.data.filter(
      item => item.regionId === regionId
    )[0];

    return !regionState;
  }
  getProjectCheckState = (projectId, regionId) => {
    const regionEnabled = this.regionEnabled();
    let { checkItemsState } = this.state;
    if (checkItemsState.data.length === 0) {
      return false;
    }
    if (!regionEnabled) {
      const project = checkItemsState.data.filter(
        item => item.projectId === projectId
      )[0];
      return project && project.checked;
    } else {
      const regionState = checkItemsState.data.filter(
        item => item.regionId === regionId
      )[0];
      for (let j = 0; j < regionState.projects.length; j++) {
        if (regionState.projects[j].projectId === projectId) {
          return regionState.projects[j].checked;
        }
      }
    }
    return null;
  };
  getCheckedProjects = () => {
    const regionEnabled = this.regionEnabled();
    let { checkItemsState } = this.state;
    const filteredData = checkItemsState.data.filter(item => item.checked);
    let projectListId = [];
    if (regionEnabled) {
      filteredData.map(item => {
        item.projects.filter(p => p.checked).map(p => {
          projectListId.push(p.projectId);
        });
      });
    } else {
      filteredData.map(i => {
        projectListId.push(i.projectId);
      });
    }

    return projectListId;
  }
  renderCaretIcon = () => {
    if (this.state.panelToggle) {
      return (
        <span>
          <i className='pe-7s-angle-down expand-ic' />
        </span>
      );
    } else {
      return (
        <span>
          <i className='pe-7s-angle-right expand-ic' />
        </span>
      );
    }
  };
  handleTitleClick = () => {
    this.onFetchRegion();
    this.onFetchProject();
    this.setState({
      panelToggle: !this.state.panelToggle
    });
  };
  onKeyPressSearchInput = e => {
    if (e.key === 'Enter') {
      this.setState({ searchInputValue: e.target.value });
    }
  };

  renderRegionSideBar = () => {
    const regionEnabled = this.regionEnabled();
    if (!regionEnabled) {
      return null;
    }
    const { SelectListRegions } = this.props;
    return (
      <div className='project-list'>
        <ul>
          {SelectListRegions.map((region, index) => {
            const checkState = this.getRegionCheckState(region.value);
            const disableState = this.getRegionDisableState(region.value);
            return (
              <li key={index}>
                <CheckBoxSingle
                  className='checkbox-default ckb-region-pick'
                  name='region'
                  ref={c => {
                    this.region = c;
                  }}
                  style={{ display: 'inline-block', bottom: '13px' }}
                  onChecked={this.onCheckRegion}
                  checked={checkState === 'checked'}
                  indeterminate={checkState === 'indeterminate'}
                  value={region.value}
                  disableClick={disableState}
                  label={region.text}
                />
              </li>
            );
          })}
        </ul>
      </div>
    );
  };

  toolTip() {
    return (
      <Tooltip className='in tooltip-siteone' id='tooltip'>
        <span>This file once was copied to this project</span>
      </Tooltip>
    );
  }

  renderWarningIcon = (projectId, checked) => {
    const {warningState} = this.state;
    if (warningState[projectId] === true && checked === true) {
      return (
        <OverlayTrigger
          placement='bottom'
          overlay={this.toolTip()}
          delayHide={10}
          delayShow={500}
        >
          <i
            className='fa fa-warning'
            style={{ marginLeft: '5px', fontSize: '15px', color: '#ffc801' }}
          />
        </OverlayTrigger>
      );
    }
    return null;
  };
  renderMainProjectList = () => {
    const searchValue = this.searchInput ? this.searchInput.value : '';
    const regionEnabled = this.regionEnabled();
    const { ProjectList, SelectListRegions } = this.props;
    let selectListFiltered = [...ProjectList];
    let selectListRegionFiltered = [...SelectListRegions];
    if (!isEmpty(searchValue)) {
      selectListFiltered = filter(
        selectListFiltered,
        project =>
          project.name.toUpperCase().indexOf(searchValue.toUpperCase()) > -1
      );

      if (regionEnabled) {
        selectListRegionFiltered = selectListFiltered.map(item => ({
          value: item.region.id,
          text: item.region.name
        }));
      }

      let newSelectListRegionFiltered = selectListRegionFiltered.map(JSON.stringify);
      let uniqueSelectListRegionFiltered = new Set(newSelectListRegionFiltered);
      const uniqueArrSelectListRegionFiltered = Array.from(uniqueSelectListRegionFiltered).map(JSON.parse);

      selectListRegionFiltered = uniqueArrSelectListRegionFiltered;
    }

    return (
      <div className='main-project-list'>
        <div className='project-search-box form-group'>
          <input
            ref={ref => {
              this.searchInput = ref;
            }}
            className='form-control search-project-input'
            placeholder='Project#'
            onKeyPress={this.onKeyPressSearchInput}
          />
          <i className='fa fa-search search-project-ic' />
        </div>
        <div className='project-list-project'>
          {regionEnabled ? (
            selectListRegionFiltered.map((region, i) => (
              <div className='project-block' key={i}>
                <p className='project-header'>{region.text}</p>
                <ul>
                  {selectListFiltered
                    .filter(project => project.region.id === region.value)
                    .map((item, index) => {
                      const checked = this.getProjectCheckState(
                        item.id,
                        item.region.id
                      );
                      return (
                        <li style={{ listStyle: 'none' }} key={index}>
                          <CheckBoxSingle
                            className='checkbox-default ckb-region-pick'
                            name='project'
                            ref={c => {
                              this.project = c;
                            }}
                            style={{ display: 'inline-block' }}
                            onChecked={this.onCheckProject}
                            checked={checked || false}
                            value={`${item.id}`}
                            label={item.name}
                          />
                          { this.renderWarningIcon(item.id, checked) }
                        </li>
                      );
                    })}
                </ul>
              </div>
            ))
          ) : (
            <div className='project-block'>
              <ul>
                {selectListFiltered.map((item, index) => {
                  const checked = this.getProjectCheckState(item.id, null);
                  return (
                    <li style={{ listStyle: 'none' }} key={index}>
                      <CheckBoxSingle
                        className='checkbox-default ckb-region-pick'
                        name='project'
                        ref={c => {
                          this.project = c;
                        }}
                        style={{ display: 'inline-block' }}
                        onChecked={this.onCheckProject}
                        checked={checked || false}
                        value={`${item.id}`}
                        label={item.name}
                      />
                      { this.renderWarningIcon(item.id, checked) }
                    </li>
                  );
                })}
              </ul>
            </div>
          )}
        </div>
      </div>
    );
  };
  renderCopyMedia = () => {
    const regionEnabled = this.regionEnabled();
    const checkedProjects = this.getCheckedProjects();

    return (
      <div className='copy-media-library-operation'>
        <Panel expanded={this.state.panelToggle} onToggle={() => {}}>
          <Panel.Heading>
            <Panel.Title
              onClick={this.handleTitleClick}
              style={{ cursor: 'pointer' }}
            >
              Pick projects to copy this file to Homeowner manual folder
              {this.renderCaretIcon()}
            </Panel.Title>
          </Panel.Heading>
          <Panel.Collapse>
            <Panel.Body>
              <div className='pick-project-wrapper'>
                {regionEnabled ? this.renderRegionSideBar() : null}
                {this.renderMainProjectList()}
              </div>
              <div>
                <button
                  className='btn btn-primary btn-siteone'
                  onClick={this.onCopy}
                  disabled={checkedProjects.length === 0}
                >
                  Copy
                </button>
              </div>
            </Panel.Body>
          </Panel.Collapse>
        </Panel>
      </div>
    );
  };
  render() {
    const defaultFileName = this.onDetectFileName();
    const { isOpen, item, MediaCategories } = this.props;
    const categoryId = MediaCategories.map(i => i.value).toString();
    const { openCopyMedia, editVideoName } = this.state;
    return (
      <Modal show={isOpen} className='copy-video-with-project-modal'>
        <Modal.Body>
          <h4 style={{whiteSpace: 'nowrap', margin: 0, textOverflow: 'ellipsis', overflow: 'hidden'}}>
            <span style={{ fontWeight: 600 }}>{item.fileName}</span>
          </h4>
          <br />
          <div className='row'>
            <div className='col-md-1 col-lg-1 col-xs-1'>
              <span>Title</span>
            </div>
            {editVideoName ? (
              <div
                style={{ bottom: '5px' }}
                className='col-md-5 col-lg-5 col-xs-5 file-name'
              >
                <InputEditAble
                  defaultValue={defaultFileName}
                  inputName='fileName'
                  autoFocus
                  maxLength='200'
                  onSubmit={this.onUpdateVideoName}
                  onCancel={this.onEditVideoName}
                  actionButtonPosition={'bottom'}
                  ignoreOnBlur={true}
                />
              </div>
            ) : (
              <div style={{ wordBreak: 'break-word', marginLeft: '15px'}} className='col-md-10 col-lg-10 col-xs-10'>
                <span
                  id={`doc-file-name-${this.uuid}`}
                  style={{ fontWeight: 600}}
                >
                  {item.fileName}
                </span>
                <i
                  className='fa fa-pencil subcontractor-edit-trade-btn'
                  onClick={this.onEditVideoName}
                />
              </div>
            )}
          </div>
          <br />
          {!isEmpty(item.category) && item.category.id === categoryId &&
            <div className='row'>
              <div className='col-md-1 col-lg-1 col-xs-1'>
                <span>Category</span>
              </div>
              <div style={{left: '15px'}} className='col-md-5 col-lg-5 col-xs-5'>
                {MediaCategories.map(media => {
                  return (
                    <CheckBoxSingle
                      id={media.value}
                      key={media.value}
                      ref={c => {
                        this.checkBox = c;
                      }}
                      style={{ display: 'inline-block', bottom: '13px' }}
                      onChecked={this.onCheckCategory}
                      checked={media.value === item.category.id}
                      value={media.value}
                      label={media.text}
                    />
                  );
                })}
              </div>
            </div>}

          {isEmpty(item.category) &&
            <div className='row'>
              <div className='col-md-1 col-lg-1 col-xs-1'>
                <span>Category</span>
              </div>
              <div style={{left: '15px'}} className='col-md-5 col-lg-5 col-xs-5'>
                {MediaCategories.map(media => {
                  return (
                    <CheckBoxSingle
                      id={media.value}
                      key={media.value}
                      ref={c => {
                        this.checkBox = c;
                      }}
                      style={{ display: 'inline-block', bottom: '13px' }}
                      onChecked={this.onCheckCategory}
                      checked={false}
                      value={media.value}
                      label={media.text}
                    />
                  );
                })}
              </div>
            </div>}

          {(!isEmpty(item.category) && item.category.id === categoryId && openCopyMedia) ? this.renderCopyMedia() : null}
          {/* {openCopyMedia && this.renderCopyMedia()} */}
          <div className='confirm-close-file-group-btn'>
            <button
              className='btn btn-primary btn-siteone-default'
              onClick={this.onClose}
            >
              Close
            </button>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}
export default MediaLibraryEditItemModal;



// WEBPACK FOOTER //
// ./src/MediaLibrary/Components/media-library-edit-item-modal.js